module.exports = __webpack_public_path__ + "img/ic_settings.f97fb634.svg";